import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthGuard } from '../../guards/auth.guard';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
	@Output() menuState = new EventEmitter();

	constructor(private authGuard: AuthGuard) {
	}

	ngOnInit() {
	}

	closeMenu(){
		this.menuState.emit('closeMenu');
	}
}
